var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "6600e9a2da"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 55 4 L 316 4 L 316 118 L 55 118 Z M 55 4 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "326f45d250"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 105.625 107.800781 C 126.726562 86.488281 155.953125 73.261719 188.078125 73.292969 C 217.699219 73.324219 244.722656 84.460938 265.21875 102.777344 C 268.15625 105.398438 272.871094 105.226562 275.652344 102.441406 L 313.257812 64.777344 C 316.320312 61.710938 316.234375 56.699219 313.050781 53.757812 C 279.535156 22.773438 234.527344 4.074219 185.152344 4.8125 C 135.234375 5.554688 90.078125 26.324219 57.273438 59.375 C 53.617188 63.058594 57.894531 107.667969 57.894531 107.667969 C 57.894531 107.667969 85.035156 128.597656 105.625 107.800781 Z M 105.625 107.800781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 69.282012,
    gradientTransform: "matrix(0.723387, 0, 0, 0.724512, 3.499652, 4.79093)",
    y1: 77.444,
    x2: 432.435996,
    gradientUnits: "userSpaceOnUse",
    y2: 77.444,
    id: "bc00f9842a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 38.798523%, 48.199463%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.990845%, 38.658142%, 48.052979%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.971008%, 38.366699%, 47.75238%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.952698%, 38.066101%, 47.442627%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.934387%, 37.765503%, 47.132874%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.914551%, 37.466431%, 46.82312%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.89624%, 37.165833%, 46.513367%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.876404%, 36.865234%, 46.203613%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.858093%, 36.564636%, 45.89386%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.838257%, 36.264038%, 45.584106%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.819946%, 35.964966%, 45.274353%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.801636%, 35.664368%, 44.9646%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.781799%, 35.36377%, 44.654846%)",
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.763489%, 35.063171%, 44.345093%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.743652%, 34.762573%, 44.035339%)",
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.725342%, 34.461975%, 43.725586%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.705505%, 34.162903%, 43.415833%)",
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.687195%, 33.862305%, 43.106079%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.668884%, 33.561707%, 42.796326%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.649048%, 33.261108%, 42.486572%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.630737%, 32.96051%, 42.176819%)",
    offset: 0.164063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.610901%, 32.661438%, 41.867065%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.59259%, 32.36084%, 41.557312%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.572754%, 32.060242%, 41.247559%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.554443%, 31.759644%, 40.937805%)",
    offset: 0.195313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.536133%, 31.459045%, 40.628052%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.516296%, 31.159973%, 40.318298%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.497986%, 30.859375%, 40.008545%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.478149%, 30.558777%, 39.698792%)",
    offset: 0.226563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.459839%, 30.258179%, 39.389038%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.440002%, 29.957581%, 39.079285%)",
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.421692%, 29.658508%, 38.769531%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.403381%, 29.35791%, 38.459778%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.383545%, 29.057312%, 38.150024%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.365234%, 28.756714%, 37.840271%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.345398%, 28.456116%, 37.530518%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.327087%, 28.155518%, 37.220764%)",
    offset: 0.289063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.307251%, 27.856445%, 36.911011%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.28894%, 27.555847%, 36.599731%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.269104%, 27.255249%, 36.289978%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.250793%, 26.954651%, 35.980225%)",
    offset: 0.320313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.232483%, 26.654053%, 35.670471%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.212646%, 26.35498%, 35.360718%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.194336%, 26.054382%, 35.050964%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.1745%, 25.753784%, 34.741211%)",
    offset: 0.351563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.156189%, 25.453186%, 34.431458%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.136353%, 25.152588%, 34.121704%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.118042%, 24.853516%, 33.811951%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.099731%, 24.552917%, 33.502197%)",
    offset: 0.382813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.079895%, 24.252319%, 33.192444%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.061584%, 23.951721%, 32.88269%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.041748%, 23.651123%, 32.572937%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.023438%, 23.352051%, 32.263184%)",
    offset: 0.414063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.003601%, 23.051453%, 31.95343%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.985291%, 22.750854%, 31.643677%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.96698%, 22.450256%, 31.333923%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.947144%, 22.149658%, 31.02417%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.928833%, 21.850586%, 30.714417%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.908997%, 21.549988%, 30.404663%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.890686%, 21.24939%, 30.09491%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.87085%, 20.948792%, 29.785156%)",
    offset: 0.476563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.852539%, 20.648193%, 29.475403%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.834229%, 20.347595%, 29.165649%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.814392%, 20.048523%, 28.855896%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.796082%, 19.747925%, 28.546143%)",
    offset: 0.507813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.776245%, 19.447327%, 28.236389%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.757935%, 19.146729%, 27.926636%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.738098%, 18.84613%, 27.616882%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.719788%, 18.547058%, 27.307129%)",
    offset: 0.539063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.701477%, 18.24646%, 26.997375%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.681641%, 17.945862%, 26.687622%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.66333%, 17.645264%, 26.377869%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.643494%, 17.344666%, 26.068115%)",
    offset: 0.570313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.625183%, 17.045593%, 25.758362%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.605347%, 16.744995%, 25.448608%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.587036%, 16.444397%, 25.138855%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.568726%, 16.143799%, 24.829102%)",
    offset: 0.601563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.548889%, 15.843201%, 24.519348%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.530579%, 15.544128%, 24.209595%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.510742%, 15.24353%, 23.899841%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.492432%, 14.942932%, 23.590088%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.472595%, 14.642334%, 23.278809%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.454285%, 14.341736%, 22.969055%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.435974%, 14.041138%, 22.659302%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.416138%, 13.742065%, 22.349548%)",
    offset: 0.664063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.397827%, 13.441467%, 22.039795%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.377991%, 13.140869%, 21.730042%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.35968%, 12.840271%, 21.420288%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.339844%, 12.539673%, 21.110535%)",
    offset: 0.695313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.321533%, 12.240601%, 20.800781%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.303223%, 11.940002%, 20.491028%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.283386%, 11.639404%, 20.181274%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.265076%, 11.338806%, 19.871521%)",
    offset: 0.726563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.245239%, 11.038208%, 19.561768%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.226929%, 10.739136%, 19.252014%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.207092%, 10.438538%, 18.942261%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.188782%, 10.137939%, 18.632507%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.170471%, 9.837341%, 18.322754%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.150635%, 9.536743%, 18.013%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.132324%, 9.237671%, 17.703247%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.112488%, 8.937073%, 17.393494%)",
    offset: 0.789063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.094177%, 8.636475%, 17.08374%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.074341%, 8.335876%, 16.773987%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.05603%, 8.035278%, 16.464233%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.03772%, 7.736206%, 16.15448%)",
    offset: 0.820313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.017883%, 7.435608%, 15.844727%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.999573%, 7.13501%, 15.534973%)",
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.979736%, 6.834412%, 15.22522%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.961426%, 6.533813%, 14.915466%)",
    offset: 0.851563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.941589%, 6.233215%, 14.605713%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.923279%, 5.934143%, 14.295959%)",
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.904968%, 5.633545%, 13.986206%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.885132%, 5.332947%, 13.676453%)",
    offset: 0.882813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.866821%, 5.032349%, 13.366699%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.846985%, 4.73175%, 13.056946%)",
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.828674%, 4.432678%, 12.747192%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.808838%, 4.13208%, 12.437439%)",
    offset: 0.914063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.790527%, 3.831482%, 12.127686%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.772217%, 3.530884%, 11.817932%)",
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.75238%, 3.230286%, 11.508179%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.73407%, 2.931213%, 11.198425%)",
    offset: 0.945313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.714233%, 2.630615%, 10.888672%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.695923%, 2.330017%, 10.578918%)",
    offset: 0.960938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.676086%, 2.029419%, 10.267639%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.657776%, 1.728821%, 9.957886%)",
    offset: 0.976563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.639465%, 1.429749%, 9.648132%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.619629%, 1.12915%, 9.338379%)",
    offset: 0.992187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.60437%, 0.889587%, 9.091187%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1d840230f7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 74 35 L 298 35 L 298 108 L 74 108 Z M 74 35 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "63e12cd2fa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 105.625 107.800781 C 126.726562 86.488281 155.953125 73.261719 188.078125 73.292969 C 217.699219 73.324219 244.722656 84.460938 265.21875 102.777344 C 268.15625 105.398438 272.871094 105.226562 275.652344 102.441406 L 297.230469 80.828125 C 295.351562 79.371094 293.5 77.84375 291.691406 76.242188 C 263.558594 51.289062 226.953125 35.40625 186.320312 35.835938 C 144.183594 36.277344 106.332031 53.492188 78.964844 81.097656 C 75.972656 84.113281 74.796875 107.71875 74.796875 107.71875 C 74.796875 107.71875 78.308594 107.398438 105.625 107.800781 Z M 105.625 107.800781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 338.51286,
    gradientTransform: "matrix(0.723387, 0, 0, 0.724512, 3.499652, 4.79093)",
    y1: 209.715835,
    x2: 134.80803,
    gradientUnits: "userSpaceOnUse",
    y2: 6.010105,
    id: "e0876e1a3d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.938965%, 37.846375%, 47.215271%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.92981%, 37.712097%, 47.076416%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.913025%, 37.443542%, 46.800232%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.89624%, 37.174988%, 46.524048%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.879456%, 36.906433%, 46.247864%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.862671%, 36.639404%, 45.970154%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.845886%, 36.37085%, 45.69397%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.827576%, 36.102295%, 45.417786%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.810791%, 35.835266%, 45.140076%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.794006%, 35.566711%, 44.863892%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.777222%, 35.298157%, 44.587708%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.760437%, 35.031128%, 44.311523%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.743652%, 34.762573%, 44.033813%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.726868%, 34.494019%, 43.757629%)",
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.710083%, 34.225464%, 43.481445%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.693298%, 33.958435%, 43.205261%)",
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.676514%, 33.68988%, 42.927551%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.658203%, 33.421326%, 42.651367%)",
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.641418%, 33.154297%, 42.375183%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.624634%, 32.885742%, 42.098999%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.607849%, 32.617188%, 41.821289%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.591064%, 32.348633%, 41.545105%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.57428%, 32.081604%, 41.268921%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.557495%, 31.813049%, 40.992737%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.54071%, 31.544495%, 40.715027%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.523926%, 31.277466%, 40.438843%)",
    offset: 0.195313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.507141%, 31.008911%, 40.162659%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.488831%, 30.740356%, 39.884949%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.472046%, 30.471802%, 39.608765%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.455261%, 30.204773%, 39.332581%)",
    offset: 0.226563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.438477%, 29.936218%, 39.056396%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.421692%, 29.667664%, 38.778687%)",
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.404907%, 29.400635%, 38.502502%)",
    offset: 0.245254
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.397278%, 29.266357%, 38.365173%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.388123%, 29.13208%, 38.226318%)",
    offset: 0.257813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.371338%, 28.863525%, 37.950134%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.354553%, 28.594971%, 37.672424%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.337769%, 28.327942%, 37.39624%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.320984%, 28.059387%, 37.120056%)",
    offset: 0.289063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.302673%, 27.790833%, 36.843872%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.285889%, 27.523804%, 36.566162%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.269104%, 27.255249%, 36.289978%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.252319%, 26.986694%, 36.013794%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.235535%, 26.71814%, 35.73761%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.21875%, 26.451111%, 35.4599%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.201965%, 26.182556%, 35.183716%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.185181%, 25.914001%, 34.907532%)",
    offset: 0.351563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.168396%, 25.646973%, 34.629822%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.151611%, 25.378418%, 34.353638%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.133301%, 25.109863%, 34.077454%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.116516%, 24.841309%, 33.80127%)",
    offset: 0.382813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.099731%, 24.57428%, 33.52356%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.082947%, 24.305725%, 33.247375%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.066162%, 24.03717%, 32.971191%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.049377%, 23.770142%, 32.695007%)",
    offset: 0.414063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.032593%, 23.501587%, 32.417297%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.015808%, 23.233032%, 32.141113%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.999023%, 22.964478%, 31.864929%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.982239%, 22.697449%, 31.588745%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.963928%, 22.428894%, 31.311035%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.947144%, 22.160339%, 31.034851%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.930359%, 21.893311%, 30.758667%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.913574%, 21.624756%, 30.482483%)",
    offset: 0.476563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.89679%, 21.356201%, 30.204773%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.880005%, 21.087646%, 29.928589%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.86322%, 20.820618%, 29.652405%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.846436%, 20.552063%, 29.376221%)",
    offset: 0.507813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.829651%, 20.283508%, 29.098511%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.812866%, 20.016479%, 28.822327%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.794556%, 19.747925%, 28.546143%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.777771%, 19.47937%, 28.268433%)",
    offset: 0.539063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.760986%, 19.210815%, 27.992249%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.744202%, 18.943787%, 27.716064%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.727417%, 18.675232%, 27.43988%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.710632%, 18.406677%, 27.16217%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.693848%, 18.139648%, 26.885986%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.677063%, 17.871094%, 26.609802%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.660278%, 17.602539%, 26.333618%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.643494%, 17.333984%, 26.055908%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.626709%, 17.066956%, 25.779724%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.608398%, 16.798401%, 25.50354%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.591614%, 16.529846%, 25.227356%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.574829%, 16.262817%, 24.949646%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.558044%, 15.994263%, 24.673462%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.54126%, 15.725708%, 24.397278%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.524475%, 15.457153%, 24.121094%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.50769%, 15.190125%, 23.843384%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.490906%, 14.92157%, 23.5672%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.474121%, 14.653015%, 23.291016%)",
    offset: 0.679687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.457336%, 14.385986%, 23.013306%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.439026%, 14.117432%, 22.737122%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.422241%, 13.848877%, 22.460938%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.405457%, 13.580322%, 22.184753%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.388672%, 13.313293%, 21.907043%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.371887%, 13.044739%, 21.630859%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.355103%, 12.776184%, 21.354675%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.338318%, 12.509155%, 21.078491%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.321533%, 12.240601%, 20.800781%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.304749%, 11.972046%, 20.524597%)",
    offset: 0.754746
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.297119%, 11.837769%, 20.387268%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.287964%, 11.703491%, 20.248413%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.269653%, 11.436462%, 19.972229%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.252869%, 11.167908%, 19.694519%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.236084%, 10.899353%, 19.418335%)",
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.219299%, 10.632324%, 19.142151%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.202515%, 10.36377%, 18.865967%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.18573%, 10.095215%, 18.588257%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.168945%, 9.82666%, 18.312073%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.152161%, 9.559631%, 18.035889%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.135376%, 9.291077%, 17.759705%)",
    offset: 0.835937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.118591%, 9.022522%, 17.481995%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.100281%, 8.755493%, 17.205811%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.083496%, 8.486938%, 16.929626%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.066711%, 8.218384%, 16.651917%)",
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.049927%, 7.949829%, 16.375732%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.033142%, 7.6828%, 16.099548%)",
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.016357%, 7.414246%, 15.823364%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.999573%, 7.145691%, 15.545654%)",
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.982788%, 6.878662%, 15.26947%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.966003%, 6.610107%, 14.993286%)",
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.949219%, 6.341553%, 14.717102%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.932434%, 6.072998%, 14.439392%)",
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.914124%, 5.805969%, 14.163208%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.897339%, 5.537415%, 13.887024%)",
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.880554%, 5.26886%, 13.61084%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.86377%, 5.001831%, 13.33313%)",
    offset: 0.960938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.846985%, 4.733276%, 13.056946%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.8302%, 4.464722%, 12.780762%)",
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.813416%, 4.196167%, 12.504578%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.796631%, 3.929138%, 12.226868%)",
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.779846%, 3.660583%, 11.950684%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ed169860c2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.425781 59 L 107 59 L 107 321 L 3.425781 321 Z M 3.425781 59 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ed0a8cc0e4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 71.902344 188.492188 C 71.613281 221.195312 84.808594 250.8125 106.25 272.105469 L 89.792969 307.675781 L 57.890625 320.539062 C 24.355469 287.132812 3.570312 240.902344 3.5 189.808594 C 3.425781 139.070312 23.992188 92.898438 57.277344 59.375 L 105.628906 107.800781 C 85.039062 128.59375 72.179688 157.089844 71.902344 188.492188 Z M 71.902344 188.492188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -52.785487,
    gradientTransform: "matrix(0.723387, 0, 0, 0.724512, 3.499652, 4.79093)",
    y1: 128.025511,
    x2: 198.519508,
    gradientUnits: "userSpaceOnUse",
    y2: 379.330515,
    id: "67ce178064"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 84.698486%, 19.999695%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.926758%, 84.507751%, 19.987488%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.780273%, 84.129333%, 19.9646%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.635315%, 83.752441%, 19.941711%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.491882%, 83.375549%, 19.918823%)",
    offset: 0.282804
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.420166%, 83.187866%, 19.908142%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.346924%, 82.998657%, 19.895935%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.201965%, 82.621765%, 19.873047%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.058533%, 82.246399%, 19.851685%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.913574%, 81.869507%, 19.828796%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.768616%, 81.492615%, 19.805908%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.625183%, 81.115723%, 19.78302%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.480225%, 80.738831%, 19.760132%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.336792%, 80.363464%, 19.737244%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.191833%, 79.986572%, 19.715881%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.046875%, 79.60968%, 19.692993%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.903442%, 79.232788%, 19.670105%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.758484%, 78.855896%, 19.647217%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.613525%, 78.479004%, 19.624329%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.470093%, 78.103638%, 19.60144%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.325134%, 77.726746%, 19.578552%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.180176%, 77.349854%, 19.55719%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.036743%, 76.972961%, 19.534302%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.891785%, 76.596069%, 19.511414%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.746826%, 76.220703%, 19.488525%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.603394%, 75.843811%, 19.465637%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.458435%, 75.466919%, 19.442749%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.315002%, 75.090027%, 19.421387%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.170044%, 74.713135%, 19.398499%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.025085%, 74.336243%, 19.37561%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.881653%, 73.960876%, 19.352722%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.736694%, 73.583984%, 19.329834%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.591736%, 73.207092%, 19.306946%)",
    offset: 0.717196
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.52002%, 73.019409%, 19.296265%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.448303%, 72.8302%, 19.284058%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.303345%, 72.453308%, 19.262695%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.158386%, 72.077942%, 19.239807%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.014954%, 71.70105%, 19.216919%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.920349%, 71.455383%, 19.20166%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.898987%, 71.398926%, 19.198608%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.898987%, 71.398926%, 19.198608%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6eb968af55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 34 81 L 107 81 L 107 299 L 34 299 Z M 34 81 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0d09d6f130"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 71.902344 188.492188 C 71.613281 221.195312 84.808594 250.8125 106.25 272.105469 L 79.808594 298.59375 C 52.363281 271.296875 35.167969 233.671875 34.511719 192.027344 C 33.824219 148.707031 50.875 109.433594 78.96875 81.105469 L 105.628906 107.800781 C 85.039062 128.59375 72.179688 157.089844 71.902344 188.492188 Z M 71.902344 188.492188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 198.522006,
    gradientTransform: "matrix(0.723387, 0, 0, 0.724512, 3.499652, 4.79093)",
    y1: 349.038006,
    x2: -1.632997,
    gradientUnits: "userSpaceOnUse",
    y2: 148.883003,
    id: "f86d6458f5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 84.698486%, 19.999695%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.952698%, 84.57489%, 19.992065%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.850464%, 84.312439%, 19.975281%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.743652%, 84.031677%, 19.958496%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.635315%, 83.750916%, 19.941711%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.528503%, 83.470154%, 19.924927%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.420166%, 83.189392%, 19.908142%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.311829%, 82.90863%, 19.891357%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.205017%, 82.627869%, 19.874573%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.09668%, 82.347107%, 19.857788%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.989868%, 82.066345%, 19.839478%)",
    offset: 0.250106
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.936462%, 81.92749%, 19.831848%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.881531%, 81.787109%, 19.822693%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.774719%, 81.506348%, 19.805908%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.666382%, 81.225586%, 19.789124%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.55957%, 80.944824%, 19.772339%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.451233%, 80.664062%, 19.755554%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.342896%, 80.383301%, 19.73877%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.236084%, 80.102539%, 19.721985%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.127747%, 79.821777%, 19.7052%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.020935%, 79.541016%, 19.688416%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.912598%, 79.260254%, 19.671631%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.805786%, 78.979492%, 19.654846%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.697449%, 78.69873%, 19.638062%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.590637%, 78.417969%, 19.621277%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.4823%, 78.137207%, 19.604492%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.375488%, 77.856445%, 19.586182%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.267151%, 77.575684%, 19.569397%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.158813%, 77.294922%, 19.552612%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.052002%, 77.01416%, 19.535828%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.943665%, 76.733398%, 19.519043%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.836853%, 76.452637%, 19.502258%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.728516%, 76.171875%, 19.485474%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.621704%, 75.891113%, 19.468689%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.513367%, 75.610352%, 19.451904%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.406555%, 75.32959%, 19.43512%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.298218%, 75.048828%, 19.418335%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.18988%, 74.768066%, 19.40155%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.083069%, 74.487305%, 19.384766%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.974731%, 74.206543%, 19.367981%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.86792%, 73.925781%, 19.351196%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.759583%, 73.64502%, 19.332886%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.652771%, 73.364258%, 19.316101%)",
    offset: 0.749894
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.599365%, 73.223877%, 19.308472%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.544434%, 73.083496%, 19.299316%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.437622%, 72.802734%, 19.282532%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.329285%, 72.521973%, 19.265747%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.222473%, 72.241211%, 19.248962%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.114136%, 71.960449%, 19.232178%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.005798%, 71.679688%, 19.215393%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.924927%, 71.469116%, 19.203186%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.898987%, 71.398926%, 19.198608%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0a1a5720ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 57 272 L 318 272 L 318 374.5 L 57 374.5 Z M 57 272 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d38fa54396"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 269.773438 272.203125 C 248.621094 293.191406 219.421875 305.992188 187.210938 305.789062 C 155.640625 305.585938 127.066406 292.757812 106.257812 272.097656 L 57.894531 320.535156 C 91.121094 353.632812 136.859375 374.136719 187.382812 374.292969 C 238.011719 374.449219 284.054688 353.597656 317.550781 320.054688 L 303.730469 290.457031 Z M 269.773438 272.203125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 137.107474,
    gradientTransform: "matrix(0.723387, 0, 0, 0.724512, 3.499652, 4.79093)",
    y1: 307.037486,
    x2: 387.212516,
    gradientUnits: "userSpaceOnUse",
    y2: 557.142496,
    id: "2542216d3a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 63.499451%, 39.599609%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 63.499451%, 39.599609%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 63.499451%, 39.599609%)",
    offset: 0.282413
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 63.499451%, 39.599609%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 63.386536%, 39.567566%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 63.15155%, 39.503479%)",
    offset: 0.398437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 62.904358%, 39.434814%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 62.65564%, 39.36615%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 62.408447%, 39.299011%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 62.161255%, 39.230347%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 61.914062%, 39.161682%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 61.66687%, 39.093018%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 61.418152%, 39.025879%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 61.170959%, 38.957214%)",
    offset: 0.460937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 60.923767%, 38.88855%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 60.676575%, 38.821411%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 60.429382%, 38.752747%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 60.180664%, 38.684082%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 59.933472%, 38.616943%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 59.686279%, 38.548279%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 59.439087%, 38.479614%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 59.191895%, 38.412476%)",
    offset: 0.523437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 58.943176%, 38.343811%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 58.695984%, 38.275146%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 58.448792%, 38.208008%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 58.201599%, 38.139343%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 57.954407%, 38.070679%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 57.705688%, 38.002014%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 57.458496%, 37.934875%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 57.211304%, 37.866211%)",
    offset: 0.585937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 56.964111%, 37.797546%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 56.716919%, 37.730408%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 56.468201%, 37.661743%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 56.221008%, 37.593079%)",
    offset: 0.617187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 55.973816%, 37.52594%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 55.726624%, 37.457275%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 55.479431%, 37.388611%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 55.230713%, 37.321472%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 54.983521%, 37.252808%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 54.736328%, 37.184143%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 54.489136%, 37.117004%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 54.241943%, 37.04834%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 53.994751%, 36.979675%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 53.78418%, 36.921692%)",
    offset: 0.717587
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 53.69873%, 36.898804%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 53.69873%, 36.898804%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bd19e27a75"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79 272 L 297 272 L 297 344 L 79 344 Z M 79 272 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "206c81e367"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 269.769531 272.199219 C 248.617188 293.191406 219.421875 305.992188 187.210938 305.789062 C 155.640625 305.589844 127.066406 292.761719 106.257812 272.097656 L 79.808594 298.589844 C 107.554688 326.191406 145.769531 343.253906 187.964844 343.253906 C 230.160156 343.253906 268.371094 326.191406 296.117188 298.589844 Z M 269.769531 272.199219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 360.580014,
    gradientTransform: "matrix(0.723387, 0, 0, 0.724512, 3.499652, 4.79093)",
    y1: 511.091004,
    x2: 161.964016,
    gradientUnits: "userSpaceOnUse",
    y2: 312.475012,
    id: "fb86ac96ee"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 63.499451%, 39.599609%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 63.374329%, 39.564514%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 63.114929%, 39.492798%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 62.843323%, 39.41803%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 62.571716%, 39.343262%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 62.30011%, 39.268494%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 62.026978%, 39.193726%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 61.755371%, 39.118958%)",
    offset: 0.247238
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 61.619568%, 39.080811%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 61.483765%, 39.042664%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 61.212158%, 38.967896%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 60.940552%, 38.893127%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 60.668945%, 38.818359%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 60.397339%, 38.743591%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 60.125732%, 38.668823%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 59.854126%, 38.594055%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 59.580994%, 38.519287%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 59.309387%, 38.444519%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 59.037781%, 38.369751%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 58.766174%, 38.294983%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 58.494568%, 38.220215%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 58.222961%, 38.145447%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 57.951355%, 38.070679%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 57.679749%, 37.994385%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 57.406616%, 37.919617%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 57.13501%, 37.844849%)",
    offset: 0.752762
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 56.999207%, 37.808228%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 56.863403%, 37.770081%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 56.591797%, 37.695312%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 56.32019%, 37.620544%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 56.048584%, 37.545776%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 55.776978%, 37.471008%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 55.505371%, 37.39624%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.699768%, 55.233765%, 37.321472%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "63571327bf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 188 163 L 372.425781 163 L 372.425781 321 L 188 321 Z M 188 163 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f44edc5f3c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 372.425781 170.566406 C 372.425781 166.925781 369.480469 163.972656 365.84375 163.972656 L 194.140625 163.972656 C 190.882812 163.972656 188.242188 166.617188 188.242188 169.878906 L 188.242188 226.742188 C 188.242188 230.003906 190.882812 232.648438 194.140625 232.648438 L 277.996094 232.648438 C 286.632812 232.648438 291.996094 242.089844 287.554688 249.507812 C 282.59375 257.785156 276.628906 265.375 269.839844 272.125 C 269.816406 272.148438 269.796875 272.175781 269.769531 272.199219 L 317.558594 320.0625 C 319.816406 317.800781 322.105469 315.542969 324.410156 313.273438 C 354.269531 280.109375 372.425781 236.109375 372.425781 188.109375 Z M 372.425781 170.566406 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 295.201493,
    gradientTransform: "matrix(0.723387, 0, 0, 0.724512, 3.499652, 4.79093)",
    y1: 179.890483,
    x2: 530.230498,
    gradientUnits: "userSpaceOnUse",
    y2: 414.919488,
    id: "81ad09ed54"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.798584%, 68.199158%, 95.698547%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.798584%, 68.199158%, 95.698547%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.798584%, 68.199158%, 95.698547%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.714661%, 68.144226%, 95.69397%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.476624%, 67.991638%, 95.680237%)",
    offset: 0.304687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.16687%, 67.791748%, 95.661926%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.858643%, 67.591858%, 95.64209%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.548889%, 67.391968%, 95.623779%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.239136%, 67.192078%, 95.605469%)",
    offset: 0.335937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.929382%, 66.993713%, 95.587158%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.619629%, 66.793823%, 95.568848%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.311401%, 66.593933%, 95.550537%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.001648%, 66.394043%, 95.530701%)",
    offset: 0.367187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.691895%, 66.194153%, 95.51239%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.382141%, 65.995789%, 95.49408%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.072388%, 65.795898%, 95.475769%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.76416%, 65.596008%, 95.457458%)",
    offset: 0.398437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.454407%, 65.396118%, 95.439148%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.144653%, 65.196228%, 95.419312%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.8349%, 64.997864%, 95.401001%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.525146%, 64.797974%, 95.38269%)",
    offset: 0.429687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.216919%, 64.598083%, 95.36438%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.907166%, 64.398193%, 95.346069%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.597412%, 64.198303%, 95.327759%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.287659%, 63.999939%, 95.307922%)",
    offset: 0.458329
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.133545%, 63.900757%, 95.298767%)",
    offset: 0.460937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.977905%, 63.800049%, 95.289612%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.669678%, 63.600159%, 95.271301%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.359924%, 63.400269%, 95.252991%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.050171%, 63.200378%, 95.23468%)",
    offset: 0.492187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.740417%, 63.000488%, 95.21637%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.430664%, 62.802124%, 95.196533%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.122437%, 62.602234%, 95.178223%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.812683%, 62.402344%, 95.159912%)",
    offset: 0.523437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.50293%, 62.202454%, 95.141602%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.193176%, 62.002563%, 95.123291%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.883423%, 61.804199%, 95.10498%)",
    offset: 0.541671
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.729309%, 61.705017%, 95.095825%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.575195%, 61.604309%, 95.085144%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.265442%, 61.404419%, 95.066833%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.955688%, 61.204529%, 95.048523%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.645935%, 61.004639%, 95.030212%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.336182%, 60.806274%, 95.011902%)",
    offset: 0.585937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.027954%, 60.606384%, 94.993591%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.718201%, 60.406494%, 94.973755%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.408447%, 60.206604%, 94.955444%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.098694%, 60.006714%, 94.937134%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.78894%, 59.80835%, 94.918823%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.480713%, 59.608459%, 94.900513%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.170959%, 59.408569%, 94.880676%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.861206%, 59.208679%, 94.862366%)",
    offset: 0.648437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.551453%, 59.008789%, 94.844055%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.241699%, 58.810425%, 94.825745%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.933472%, 58.610535%, 94.807434%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.623718%, 58.410645%, 94.789124%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.313965%, 58.210754%, 94.769287%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.004211%, 58.010864%, 94.750977%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.694458%, 57.8125%, 94.732666%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.38623%, 57.61261%, 94.714355%)",
    offset: 0.710937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.076477%, 57.41272%, 94.696045%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.766724%, 57.21283%, 94.677734%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.45697%, 57.012939%, 94.657898%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.147217%, 56.814575%, 94.639587%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.838989%, 56.614685%, 94.621277%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.529236%, 56.414795%, 94.602966%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.219482%, 56.214905%, 94.584656%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.909729%, 56.015015%, 94.566345%)",
    offset: 0.773437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.599976%, 55.81665%, 94.546509%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.291748%, 55.61676%, 94.528198%)",
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.981995%, 55.41687%, 94.509888%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.812622%, 55.308533%, 94.499207%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.798889%, 55.299377%, 94.499207%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.798889%, 55.299377%, 94.499207%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "afa48ff923"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 188 196 L 336 196 L 336 299 L 188 299 Z M 188 196 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "db95989207"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 333.683594 237.925781 C 340.433594 217.492188 325.3125 196.425781 303.828125 196.425781 L 188.242188 196.425781 L 188.242188 226.742188 C 188.242188 230.003906 190.882812 232.648438 194.140625 232.648438 L 277.996094 232.648438 C 286.632812 232.648438 291.996094 242.089844 287.554688 249.507812 C 282.609375 257.761719 276.667969 265.324219 269.90625 272.058594 C 269.859375 272.105469 269.820312 272.152344 269.773438 272.199219 L 296.117188 298.585938 C 310.121094 284.671875 321.449219 268.058594 329.285156 249.597656 C 330.898438 245.777344 332.367188 241.886719 333.683594 237.925781 Z M 333.683594 237.925781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 464.227003,
    gradientTransform: "matrix(0.723387, 0, 0, 0.724512, 3.499652, 4.79093)",
    y1: 407.052993,
    x2: 288.529007,
    gradientUnits: "userSpaceOnUse",
    y2: 231.355008,
    id: "b4a315a94e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.798584%, 68.199158%, 95.698547%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.676514%, 68.119812%, 95.690918%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.375916%, 67.926025%, 95.674133%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.01886%, 67.695618%, 95.652771%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.66333%, 67.46521%, 95.631409%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.306274%, 67.236328%, 95.610046%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.949219%, 67.00592%, 95.588684%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.593689%, 66.775513%, 95.567322%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.236633%, 66.546631%, 95.545959%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.881104%, 66.316223%, 95.524597%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.524048%, 66.087341%, 95.503235%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.168518%, 65.856934%, 95.481873%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.811462%, 65.626526%, 95.46051%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.455933%, 65.397644%, 95.439148%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.098877%, 65.167236%, 95.417786%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.741821%, 64.936829%, 95.396423%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.386292%, 64.707947%, 95.375061%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.029236%, 64.477539%, 95.353699%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.673706%, 64.247131%, 95.332336%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.31665%, 64.01825%, 95.310974%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.961121%, 63.787842%, 95.289612%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.604065%, 63.557434%, 95.26825%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.248535%, 63.328552%, 95.246887%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.891479%, 63.098145%, 95.225525%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.534424%, 62.869263%, 95.202637%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.178894%, 62.638855%, 95.181274%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.821838%, 62.408447%, 95.159912%)",
    offset: 0.401285
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.644836%, 62.294006%, 95.149231%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.466309%, 62.179565%, 95.13855%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.109253%, 61.949158%, 95.117188%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.753723%, 61.71875%, 95.095825%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.396667%, 61.489868%, 95.074463%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.041138%, 61.25946%, 95.053101%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.684082%, 61.029053%, 95.031738%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.327026%, 60.800171%, 95.010376%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.971497%, 60.569763%, 94.989014%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.614441%, 60.339355%, 94.967651%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.258911%, 60.110474%, 94.946289%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.901855%, 59.880066%, 94.924927%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.546326%, 59.651184%, 94.903564%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.18927%, 59.420776%, 94.882202%)",
    offset: 0.598715
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.012268%, 59.306335%, 94.871521%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.83374%, 59.190369%, 94.86084%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.476685%, 58.961487%, 94.839478%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.119629%, 58.731079%, 94.818115%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.764099%, 58.500671%, 94.796753%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.407043%, 58.27179%, 94.775391%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.051514%, 58.041382%, 94.754028%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.694458%, 57.810974%, 94.732666%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.338928%, 57.582092%, 94.711304%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.981873%, 57.351685%, 94.689941%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.626343%, 57.121277%, 94.668579%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.269287%, 56.892395%, 94.647217%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.912231%, 56.661987%, 94.625854%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.556702%, 56.433105%, 94.604492%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.199646%, 56.202698%, 94.58313%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.844116%, 55.97229%, 94.561768%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.487061%, 55.743408%, 94.540405%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.131531%, 55.513%, 94.519043%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.875183%, 55.348206%, 94.503784%)",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6600e9a2da)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#326f45d250)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bc00f9842a)",
    d: "M 53.617188 4.074219 L 53.617188 128.597656 L 316.320312 128.597656 L 316.320312 4.074219 Z M 53.617188 4.074219 ",
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1d840230f7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#63e12cd2fa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#e0876e1a3d)",
    d: "M 74.796875 35.40625 L 74.796875 107.800781 L 297.230469 107.800781 L 297.230469 35.40625 Z M 74.796875 35.40625 ",
    fillRule: "nonzero"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ed169860c2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ed0a8cc0e4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#67ce178064)",
    d: "M 3.425781 59.375 L 3.425781 320.539062 L 106.25 320.539062 L 106.25 59.375 Z M 3.425781 59.375 ",
    fillRule: "nonzero"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6eb968af55)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0d09d6f130)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#f86d6458f5)",
    d: "M 33.824219 81.105469 L 33.824219 298.59375 L 106.25 298.59375 L 106.25 81.105469 Z M 33.824219 81.105469 ",
    fillRule: "nonzero"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0a1a5720ac)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d38fa54396)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#2542216d3a)",
    d: "M 57.894531 272.097656 L 57.894531 374.449219 L 317.550781 374.449219 L 317.550781 272.097656 Z M 57.894531 272.097656 ",
    fillRule: "nonzero"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bd19e27a75)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#206c81e367)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fb86ac96ee)",
    d: "M 79.808594 272.097656 L 79.808594 343.253906 L 296.117188 343.253906 L 296.117188 272.097656 Z M 79.808594 272.097656 ",
    fillRule: "nonzero"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#63571327bf)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f44edc5f3c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#81ad09ed54)",
    d: "M 188.242188 163.972656 L 188.242188 320.0625 L 372.425781 320.0625 L 372.425781 163.972656 Z M 188.242188 163.972656 ",
    fillRule: "nonzero"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#afa48ff923)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#db95989207)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b4a315a94e)",
    d: "M 188.242188 196.425781 L 188.242188 298.585938 L 340.433594 298.585938 L 340.433594 196.425781 Z M 188.242188 196.425781 ",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey5);
export default __webpack_public_path__ + "static/media/key5.f32ab729bd773a8f029704102d4f1196.svg";
export { ForwardRef as ReactComponent };